<template>
  <div class="footer-box">
    <div class="footer-top">
      <a-popover placement="bottomLeft">
        <template slot="content">
          <div class="partner-box">
            <span class="partner" @click="goDeRen">仁德基金会</span>
            <span class="partner marginL" @click="go24">希望24热线</span>
          </div>
        </template>
        <div>公益伙伴</div>
      </a-popover>

      <a-popover placement="bottomLeft">
        <template slot="content">
          <div class="link" @click="goDF">
            <img src="../assets/logo1.svg" alt="" />
          </div>
        </template>
        <div>友情链接</div>
      </a-popover>

      <a-popover placement="bottomRight">
        <template slot="content">
          <div class="information">
            <div class="information-first">
              <div>电话：021-60740000-0131</div>
              <div>邮编：200122</div>
            </div>
            <div class="information-sec">
<!--              <div>传真：（021）2036 0001-18</div>-->
              <div>邮箱：gyjjh@easthope.org</div>
            </div>
            <div class="information-third">
              <div>地址：上海市浦东新区世纪大道1777号东方希望大厦3楼</div>
            </div>
          </div>
        </template>
        <div>联系方式</div>
      </a-popover>
    </div>
    <div class="footer-main">
      <div class="footer-main-left">
        <div>
          <div>关于我们</div>
          <div
            v-for="(v, i) in aboutList"
            :key="i"
            @click="goAbout(i, v.linkTo)"
            @mouseover="aboutCur = i + 1"
            @mouseout="aboutCur = -1"
            :style="{ color: aboutCur == i + 1 ? '#C1141E' : '' }"
            style="cursor: pointer"
          >
            {{ v.name }}
          </div>
        </div>
        <div>
          <div>机构项目</div>
          <div
            v-for="(v, i) in projectsList"
            :key="i"
            @click="goProject(i, v.linkTo)"
            @mouseover="proCur = i + 1"
            @mouseout="proCur = -1"
            :style="{ color: proCur == i + 1 ? '#C1141E' : '' }"
            style="cursor: pointer"
          >
            {{ v.name }}
          </div>
        </div>
        <div>
          <div>信息公示</div>
          <div
            v-for="(v, i) in imformationList"
            :key="i"
            @click="goImf(i, v.linkTo)"
            @mouseover="imfCur = i + 1"
            @mouseout="imfCur = -1"
            :style="{ color: imfCur == i + 1 ? '#C1141E' : '' }"
            style="cursor: pointer"
          >
            {{ v.name }}
          </div>
        </div>
        <div>
          <div>新闻中心</div>
          <div
            v-for="(v, i) in newsList"
            :key="i"
            @click="goNews(i, v.linkTo)"
            @mouseover="newCur = i + 1"
            @mouseout="newCur = -1"
            :style="{ color: newCur == i + 1 ? '#C1141E' : '' }"
            style="cursor: pointer"
          >
            {{ v.name }}
          </div>
        </div>
        <div>
          <div>志愿之家</div>
          <div
            v-for="(v, i) in volList"
            :key="i"
            @click="goVol(i, v.linkTo)"
            @mouseover="volCur = i + 1"
            @mouseout="volCur = -1"
            :style="{ color: volCur == i + 1 ? '#C1141E' : '' }"
            style="cursor: pointer"
          >
            {{ v.name }}
          </div>
        </div>
        <div>
          <div>我要捐款</div>
          <div
            v-for="(v, i) in moneyList"
            :key="i"
            @click="goMoney(i, v.linkTo)"
            @mouseover="moneyCur = i + 1"
            @mouseout="moneyCur = -1"
            :style="{ color: moneyCur == i + 1 ? '#C1141E' : '' }"
            style="cursor: pointer"
          >
            {{ v.name }}
          </div>
        </div>
      </div>
      <div class="footer-main-right">
        <div><img src="../assets/logoleft.svg" alt="" /></div>
        <div>
          <div><img src="../assets/erweima.png" alt="" /></div>
          <div>
            <!-- <div class="weiboBtn">
              <img src="../assets/weibos.svg" alt="" />
              <span>新浪微博</span>
            </div> -->
            <div class="weiboBtn" style="margin-top: 10px">
              <img src="../assets/weixins.svg" alt="" />
              <span>微信平台</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-bottom">
      <div class="copyright">
        <span>Copyright © 2021-2022. East Hope Group All rights reserved. </span
        ><br />
        <span>隐私保护 东方希望集团 版权所有 </span>
        <a href="http://beian.miit.gov.cn" target="_blank">
          <img src="~@/assets/beian.png" />沪ICP备05035603号-1
        </a>
        <a
          href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502007884"
          target="_blank"
        >
          <img src="~@/assets/beian.png" />沪公网安备 31011502007884号
        </a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      aboutList: [
        { name: "基金会简介", linkTo: "/foundation" },
        { name: "宗旨及使命", linkTo: "/foundation/purpose" },
        { name: "章程制度", linkTo: "/foundation/constitutionSystem" },
        { name: "组织机构", linkTo: "/foundation/organization" },
        { name: "理事会成员", linkTo: "/foundation/councilMembers" },
      ],
      aboutCur: -1,
      projectsList: [
        { name: "安全课堂", linkTo: "/projects" },
        { name: "希望助学", linkTo: "/projects/hopeStudy" },
        { name: "希望行动", linkTo: "/projects/hopeAction" },
      ],
      proCur: -1,
      imformationList: [
        { name: "希冀月刊", linkTo: "/information" },
        { name: "希冀年报", linkTo: "/information/yearly" },
        { name: "理事会议", linkTo: "/information/meeting" },
        { name: "审计报告", linkTo: "/information/auditReport" },
        { name: "管理制度", linkTo: "/information/management" },
      ],
      imfCur: -1,
      newsList: [
        { name: "机构动态", linkTo: "/newcenter" },
        { name: "媒体报道", linkTo: "/newCenter/media" },
        { name: "业界资讯", linkTo: "/newCenter/industry" },
        { name: "获得荣誉", linkTo: "/newCenter/honor" },
        { name: "公益活动", linkTo: "/newCenter/activities" },
      ],
      newCur: -1,
      volList: [
        { name: "志愿者风采", linkTo: "/volunteer" },
        { name: "志愿者服务站", linkTo: "/volunteer/station" },
      ],
      volCur: -1,
      moneyList: [{ name: "我要捐款", linkTo: "/contribution" }],
      moneyCur: -1,
    };
  },
  methods: {
    goAbout(i, path) {
      this.$router.push({
        path: path,
        query: {
          title: "关于我们",
          curIndex: i,
          index: 1,
        },
      });
    },
    goProject(i, path) {
      this.$router.push({
        path: path,
        query: {
          title: "机构项目",
          curIndex: i,
          index: 2,
        },
      });
    },
    goImf(i, path) {
      this.$router.push({
        path: path,
        query: {
          index: 3,
          title: "信息公示",
          curIndex: i,
        },
      });
    },
    goNews(i, path) {
      this.$router.push({
        path: path,
        query: {
          index: 4,
          title: "新闻中心",
          curIndex: i,
        },
      });
    },
    goVol(i, path) {
      this.$router.push({
        path: path,
        query: {
          index: 5,
          title: "志愿之家",
          curIndex: i,
        },
      });
    },
    goMoney(i, path) {
      this.$router.push({
        path: path,
        query: {
          index: 6,
          title: "我要捐款",
          curIndex: i,
        },
      });
    },
    goDeRen() {
      window.open("https://www.rendefoundation.org/");
    },
    go24() {
      window.open("http://blog.sina.com.cn/lcicenter");
    },
    goDF() {
      window.open("https://www.easthope.cn/ehw/vm/index_v2");
    },
  },
};
</script>
<style scoped lang="scss">
.footer-box {
  width: 100%;
  .footer-top {
    width: 100%;
    height: 60px;
    line-height: 60px;
    display: flex;
    justify-content: center;
    background: #f8f8f8;
    :nth-child(1),
    :nth-child(2) {
      &:after {
        content: "";
        margin-left: 30px;
        padding-left: 30px;
        border-left: 1px solid #c0c4cc;
        height: 12px;
        display: inline-block;
        vertical-align: middle;
      }
    }
  }
  .footer-main {
    display: flex;
    width: 1200px;
    margin: 0 auto;
    .footer-main-left {
      padding: 56px 0;
      display: flex;
      > div:not(:first-child) {
        margin-left: 78px;
      }
      > div {
        :nth-child(1) {
          font-size: 16px;
          color: #645f5f;
        }
        > div:not(:first-child) {
          margin-top: 12px;
        }
      }
      &:after {
        content: "";
        margin-left: 80px;
        padding-left: 70px;
        border-left: 1px solid #e3e3e3;
        height: 242px;
        display: inline-block;
        vertical-align: middle;
      }
    }
    .footer-main-right {
      padding: 56px 0;

      > div:nth-child(1) {
        img {
          width: 200px;
          height: 48px;
        }
      }
      > div:nth-child(2) {
        display: flex;
        margin-top: 28px;
        align-items: center;
        img {
          width: 122px;
          height: 122px;
        }
        .weiboBtn {
          width: 106px;
          height: 36px;
          border: 0.5px solid #e4e4e4;
          border-radius: 18.5px;
          text-align: center;
          line-height: 36px;
          img {
            width: 16px;
            height: 16px;
            vertical-align: sub;
          }
          span {
            margin-left: 5px;
          }
        }
      }
    }
  }
  .footer-bottom {
    // position: fixed;
    // width: 100%;
    // bottom: 0;
    // padding: 0 16px;
    // margin: 48px 0 24px;
    // text-align: center;

    width: 100%;
    // height: 40px;
    // line-height: 40px;
    text-align: center;
    padding-bottom: 20px;
    // border-top: 2px solid #fbfbfb;

    .links {
      margin-bottom: 8px;
      font-size: 14px;
      a {
        color: rgba(0, 0, 0, 0.45);
        transition: all 0.3s;
        &:not(:last-child) {
          margin-right: 40px;
        }
      }
    }
    .copyright {
      color: rgba(0, 0, 0, 0.45);
      font-size: 14px;
    }
  }
}
.partner-box {
  padding: 10px 25px 16px 20px;
}
.partner {
  font-size: 14px;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  color: #666666;
  &:hover {
    color: #c1141e;
    cursor: pointer;
  }
}
.marginL {
  margin-left: 20px;
}
.information {
  padding: 20px 44px 20px 20px;

  .information-first {
    display: flex;
    > div:nth-child(2) {
      margin-left: 70px;
    }
  }
  .information-sec {
    display: flex;
    margin-top: 10px;
    > div:nth-child(2) {
      margin-left: 50px;
    }
  }
  .information-third {
    margin-top: 10px;
  }
}
.link {
  padding: 10px 92px 10px 20px;
  cursor: pointer;
  img {
    width: 96px;
    height: 29px;
  }
}
</style>
